import { render, staticRenderFns } from "./CsatMetrics.vue?vue&type=template&id=b81f04ce&scoped=true&"
import script from "./CsatMetrics.vue?vue&type=script&lang=js&"
export * from "./CsatMetrics.vue?vue&type=script&lang=js&"
import style0 from "./CsatMetrics.vue?vue&type=style&index=0&id=b81f04ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81f04ce",
  null
  
)

export default component.exports